import { catalog } from '@nolens/i18n';
import type { FontChoice } from '@nolens/domain';

export const brandText = catalog(
  {
    spaceNotFound: 'Space not found.',
    ownerOnly: "Only the space's owner changes the brand.",
    tryHere: 'You can try it out here; to save, choose a plan.',
    seePlans: 'See plans',
    saved: 'Brand saved.',
    logoUploaded: 'Logo uploaded.',
    fontUploaded: 'Font uploaded.',
    title: (name: string) => `Brand of ${name}`,
    hint: 'Applies to the public page, embedded guides and exports (HTML, PDF, PowerPoint).',
    companyName: 'Company name',
    companyNameHint: (name: string) =>
      `Shown in the header and on the cover of exports. Empty = “${name}”.`,
    mainColor: 'Main color',
    weakColor: (c: string) => `On white, text uses ${c} so it's easy to read.`,
    pickColor: 'Pick the color',
    coverColor: 'Cover color',
    coverColorHint: 'Background of the cover and closing slide of presentations, HTML and PDF.',
    highlightColor: 'Highlight color',
    highlightColorHint: 'Rule and date on the cover.',
    logo: 'Logo',
    currentLogo: 'Current logo',
    replace: 'Replace',
    upload: 'Upload',
    logoFormats: ' (PNG, JPEG or WebP, up to 1 MB)',
    remove: 'Remove',
    font: 'Font',
    uploadFontFirst: ' — upload the file',
    replaceFont: 'Replace the font',
    uploadFont: 'Upload your font',
    fontFormats: ' (WOFF2, up to 2 MB)',
    footer: 'Footer',
    footerHint: 'Shown at the end of exports and on the public page (e.g. “Acme · internal use”).',
    saveBrand: 'Save brand',
    preview: 'Preview',
    sampleTitle: 'How to request time off',
    sampleMeta: '3 steps · about 1 min',
    sampleStep: 'Click “Requests”',
    sampleUrl: 'hr.example.com/requests',
    button: 'Button',
    madeWith: 'Made with Nolens Guides',
    nowAuto: ' Now: automatic.',
    pickNamed: (label: string) => `Pick the ${label.toLowerCase()}`,
    automatic: 'Automatic',
    coverPreview: 'Presentation cover',
    guide: 'Guide',
    steps: 'Steps',
    fontName: (f: FontChoice) =>
      ({
        inter: 'Inter (Nolens)',
        system: 'System font',
        serif: 'Serif',
        mono: 'Monospace',
        custom: 'Your font (WOFF2)',
      })[f],
  },
  {
    'pt-PT': {
      spaceNotFound: 'Espaço não encontrado.',
      ownerOnly: 'Só o dono do espaço muda a marca.',
      tryHere: 'Pode experimentar aqui; para guardar, escolha um plano.',
      seePlans: 'Ver planos',
      saved: 'Marca guardada.',
      logoUploaded: 'Logótipo enviado.',
      fontUploaded: 'Letra enviada.',
      title: (name) => `Marca de ${name}`,
      hint: 'Aplica-se à página pública, aos guias incorporados e às exportações (HTML, PDF, PowerPoint).',
      companyName: 'Nome da empresa',
      companyNameHint: (name) =>
        `Aparece no cabeçalho e na capa das exportações. Vazio = «${name}».`,
      mainColor: 'Cor principal',
      weakColor: (c) => `Sobre branco, o texto usa ${c} para se ler bem.`,
      pickColor: 'Escolher a cor',
      coverColor: 'Cor da capa',
      coverColorHint: 'Fundo da capa e do fecho das apresentações, HTML e PDF.',
      highlightColor: 'Cor de destaque',
      highlightColorHint: 'Régua e data na capa.',
      logo: 'Logótipo',
      currentLogo: 'Logótipo atual',
      replace: 'Trocar',
      upload: 'Enviar',
      logoFormats: ' (PNG, JPEG ou WebP, até 1 MB)',
      remove: 'Remover',
      font: 'Letra',
      uploadFontFirst: ' — envie o ficheiro',
      replaceFont: 'Trocar a letra',
      uploadFont: 'Enviar a sua letra',
      fontFormats: ' (WOFF2, até 2 MB)',
      footer: 'Rodapé',
      footerHint: 'Aparece no fim das exportações e da página pública (ex.: «Acme · uso interno»).',
      saveBrand: 'Guardar marca',
      preview: 'Pré-visualização',
      sampleTitle: 'Como pedir férias',
      sampleMeta: '3 passos · cerca de 1 min',
      sampleStep: 'Clique em «Pedidos»',
      sampleUrl: 'rh.exemplo.pt/pedidos',
      button: 'Botão',
      madeWith: 'Feito com Nolens Guides',
      nowAuto: ' Agora: automática.',
      pickNamed: (label) => 'Escolher a ' + label.toLowerCase(),
      automatic: 'Automática',
      coverPreview: 'Capa das apresentações',
      guide: 'Guia',
      steps: 'Passos',
      fontName: (f) =>
        ({
          inter: 'Inter (Nolens)',
          system: 'Letra do sistema',
          serif: 'Serifada',
          mono: 'Monoespaçada',
          custom: 'A sua letra (WOFF2)',
        })[f],
    },
  },
);
